import { Item, IDoc } from '../../types/orders';
import { axiosInstance } from '../axiosInstance';

export const postOrders = async (
  data: Item[],
  token: string | null,
): Promise<IDoc | undefined> => {
  const headers: { Authorization?: string } = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  const response = await axiosInstance.post(`/view/orders/create`, data, {
    headers: headers,
  });
  return response.data;
};
